import axios from "axios";
import { Base64 } from "js-base64";
const baseURL = "/api/user/";

export default {
  getUsers() {
    return axios.get(baseURL + "info");
  },
  createUser(user) {
    return axios.post(baseURL + "user/", { ...user });
  },
  updatePassword(passwordJson) {
    passwordJson.password = Base64.encode(passwordJson.password.toString());
    passwordJson.newPassword = Base64.encode(
      passwordJson.newPassword.toString()
    );
    return axios.put(baseURL + `password`, { ...passwordJson });
  },
  updateEmail(emailJsom) {
    return axios.put(baseURL + `setting`, { ...emailJsom });
  }
};
